import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Button, Grid2 } from "@mui/material";
import {
	ColDef,
	EditableCallbackParams,
	ICellRendererParams,
} from "ag-grid-enterprise";

const moment = getMomentTz();

const renderStatusCell = (props: ICellRendererParams) => {
	const status = props.data.FormInstanceStatusCode;
	const answers = props.data.Answered;
	let color = "#ccc";
	if (status === "O" && answers > 0) color = "green";
	if (status === "S") color = "#5164ff";
	return (
		<div
			style={{
				width: "10px",
				height: "10px",
				borderRadius: "50%",
				backgroundColor: color,
			}}
		/>
	);
};

type Props = {
	showContextMenu: Function;
};
export const useTableData = ({ showContextMenu }: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "ProductionDate",
			headerName: "Date",
			flex: 3,
			valueGetter: (params) => {
				return moment(params?.data?.ProductionDate).format("MM/DD/YYYY");
			},
		},
		{
			field: "Shift",
			headerName: "Shift",
			flex: 1,
		},
		{
			field: "Crew",
			headerName: "Crew",
			flex: 1,
		},
		{
			field: "FormName",
			headerName: "Form Name",
			flex: 5,
		},
		{
			field: "Status",
			headerName: "Answers Status",
			flex: 2,
		},
		{
			field: "FormInstanceStatusCode",
			headerName: "",
			flex: 1,
			cellRenderer: renderStatusCell,
		},
		{
			field: "OpenTimestamp",
			headerName: "Open Time",
			flex: 4,
			valueGetter: (params) => {
				return (
					dxtToLocalServerTime(params?.data?.OpenTimestamp, "MM/dd/yy HH:mm") ||
					""
				);
			},
		},
		{
			field: "SubmitUser",
			headerName: "Submit User",
			flex: 4,
		},
		{
			field: "SubmitTimestamp",
			headerName: "Submit Time",
			flex: 4,
			valueGetter: (params) => {
				return (
					dxtToLocalServerTime(
						params?.data?.SubmitTimestamp,
						"MM/dd/yy HH:mm",
					) || ""
				);
			},
		},
		{
			field: "",
			headerName: "",
			flex: 1,
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid2
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Grid2
							container
							spacing={1}
							style={{ justifyContent: "flex-end", minWidth: 30 }}
						>
							<Grid2 size={{ md: 12, xs: 12 }}>
								<Button
									fullWidth
									style={{}}
									onClick={(e) =>
										showContextMenu(e, params.data, "formInstanceContext")
									}
								>
									<FormatListBulletedSharpIcon
										style={{ height: "auto" }}
										color="action"
									/>
								</Button>
							</Grid2>
						</Grid2>
					</Grid2>
				);
			},
		},
	];
	return { columnDefs };
};
